export function getStorage(key) {
    try {
        const expiresInStr = localStorage.getItem(key + "_expiresIn");
        if (expiresInStr) {
            const expiresIn = Math.abs(Number(expiresInStr));
            if (expiresIn > 0 && expiresIn < Date.now()) {
                removeStorage(key);
                return null;
            }
        }
        return localStorage.getItem(key);
    } catch (e) {
        console.error("getStorage error:", e);
        return null;
    }
}

export function setStorage(key, value, expires) {
    try {
        localStorage.setItem(key, value);
        if (expires === null) {
            expires = 24 * 60 * 60; // default: seconds for 1 day
        }
        if (expires !== undefined) {
            const schedule = Date.now() + expires * 1000;
            localStorage.setItem(key + "_expiresIn", String(schedule));
        }
        return true;
    } catch (e) {
        console.error("setStorage error:", e);
        return false;
    }
}

export function removeStorage(key) {
    try {
        localStorage.removeItem(key);
        localStorage.removeItem(key + "_expiresIn");
        return true;
    } catch (e) {
        console.error("removeStorage error:", e);
        return false;
    }
}
